import { render, staticRenderFns } from "./MainDocumentPage.vue?vue&type=template&id=e572e4b4&scoped=true&"
import script from "./MainDocumentPage.vue?vue&type=script&lang=js&"
export * from "./MainDocumentPage.vue?vue&type=script&lang=js&"
import style0 from "./MainDocumentPage.vue?vue&type=style&index=0&id=e572e4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e572e4b4",
  null
  
)

export default component.exports